import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element'
import axios from 'axios'
import bus from './utils/bus'
import VeLine from 'v-charts/lib/line.common'
import VePie from 'v-charts/lib/pie.common'
import VeHistogram from 'v-charts/lib/histogram.common'

import VueI18n from 'vue-i18n'
window.Vue = Vue
const lang = localStorage.getItem('lang') || 'tc'
const i18n = new VueI18n({
  locale: lang,
  messages: {
    chs: require('./i18n/chs.js'),
    tc: require('./i18n/tc.js'),
    en: require('./i18n/en.js')
  }
})
Vue.component(VeLine.name, VeLine)
Vue.component(VePie.name, VePie)
Vue.component(VeHistogram.name, VeHistogram)

Vue.use(bus)
Vue.config.productionTip = false
Vue.http = Vue.prototype.$http = axios
window.defaultStore = store
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
